import { useTranslation } from 'react-i18next';
import { InputCheckbox } from '@components/input-checkbox';
import {
  ADDON_TYPE_ACCOMMODATION,
  ADDON_TYPE_DONATION,
  ADDON_TYPE_DRINKS,
  ADDON_TYPE_INSURANCE,
  ADDON_TYPE_OTHER,
  ADDON_TYPE_TRANSPORT,
} from '@domain/addon';
import { formatCurrency } from '@utils/price-formatter/price-formatter';
import classNames from 'classnames';

import { AddOnPresetRowProps } from '../add-ons-presets-modal.type';

const DEFAULT_NAME_KEY_BY_TYPE: Record<string, string> = {
  [ADDON_TYPE_DRINKS]: 'addons:defaultDrinksName',
  [ADDON_TYPE_TRANSPORT]: 'addons:defaultTransportName',
  [ADDON_TYPE_ACCOMMODATION]: 'addons:defaultAccommodation',
  [ADDON_TYPE_INSURANCE]: 'addons:defaultInsuranceName',
  [ADDON_TYPE_DONATION]: 'addons:defaultDonationName',
  [ADDON_TYPE_OTHER]: 'addons:defaultOthersName',
};

export const AddOnPresetRow = ({ addon, checked, onToggle, disabled, dataTestId }: AddOnPresetRowProps) => {
  const { t, i18n } = useTranslation();

  const localizedName = addon.name?.[i18n.language] ?? '';
  const defaultName = DEFAULT_NAME_KEY_BY_TYPE[addon.type] ? t(DEFAULT_NAME_KEY_BY_TYPE[addon.type]) : '';
  const addonName = addon.displayName || localizedName || defaultName;

  const formattedPrice = formatCurrency({
    currency: addon.fixedPrice.currency,
    number: addon.fixedPrice.amount,
  });

  return (
    <div data-testid={dataTestId} className='flex items-center justify-between gap-4 px-3 py-3 rounded-md bg-primary'>
      <div className='flex items-center gap-2 min-w-0'>
        <InputCheckbox value={checked} name={addon.id} onChange={() => onToggle(addon.id)} disabled={disabled} />
        <label
          htmlFor={addon.id}
          className={classNames('truncate min-w-0 cursor-pointer', {
            'text-subtitle-s text-primary': checked,
            'text-body-s text-secondary': !checked,
          })}>
          {addonName}
        </label>
      </div>
      <span
        className={classNames('shrink-0', {
          'text-subtitle-s text-primary': checked,
          'text-body-s text-secondary': !checked,
        })}>
        {formattedPrice}
      </span>
    </div>
  );
};
